var open_search = function() {
  var search_popup = document.querySelector('.search-popup');
  var search_popup_overlay = document.querySelector('.search-popup-overlay');
  var body = document.querySelector('body');
  search_popup.classList.toggle("show");
  search_popup_overlay.classList.toggle("show");
  body.classList.toggle('is-searching');

  var close = document.querySelector('.search-popup-overlay.show');
  if(close){
    document.addEventListener('keydown', esc_press);
    close.addEventListener('click', show_toggle);

    function show_toggle(){
      search_popup.classList.toggle('show');
      close.classList.toggle('show');
      body.classList.toggle('is-searching');
      close.removeEventListener('click', show_toggle);
    }

    function esc_press(e){
      if(e.keyCode == 27) {
        search_popup.classList.toggle('show');
        close.classList.toggle('show');
        body.classList.toggle('is-searching');
        close.removeEventListener('click', show_toggle);
        document.removeEventListener('keydown', esc_press);
      }
    }
  }
};


var search_tab_toggle = function(e, target) {
  var tabs = document.querySelectorAll('.search-tabs li');
  tabs.forEach(item => {
    item.classList.remove('show');
  });
  e.currentTarget.classList.toggle("show");

  var results = document.querySelectorAll('div.search-result');
  results.forEach(item => {
    item.classList.remove('show');
  });

  var t = target;
  if(t == 'post'){
    var container = document.querySelector('div.searchwp-live-search-result');
    container.classList.remove('post');
    container.classList.add('post');

    var posts = document.querySelectorAll('div.search-result__post');
    posts.forEach(item => {
      item.classList.add('show');
    });
  } else if(t == 'product') {
    var container = document.querySelector('div.searchwp-live-search-result');
    container.classList.remove('post');
    var products = document.querySelectorAll('div.search-result__product');
    products.forEach(item => {
      item.classList.add('show');
    });
  }
};
